var swiper = new Swiper(".shop-by-categoryslider", {
        slidesPerView: 6.5,
        spaceBetween: 35,
        loop: false,
         pagination: {
          el: ".swiper-pagination",
           clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
       //  autoplay: {
       //      delay: 3000,
       //     disableOnInteraction: false, 
       // },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 5,
                autoplay: true
            },
            440: {
                slidesPerView: 3,
                spaceBetween: 5,
                autoplay: true
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 25
            },
            1199: {
                slidesPerView: 5,
                spaceBetween: 25
            },
            1280: {
                slidesPerView: 6,
                spaceBetween: 25
            }
        }
    });


//  var swiper = new Swiper(".happy-client", {
//          slidesPerView: 1,
//          spaceBetween: 25,
//          loop: true,
//          pagination: {
//            el: ".swiper-pagination",
//             clickable: true,
//          },
//     navigation: {
//              nextEl: ".swiper-button-next",
//              prevEl: ".swiper-button-prev"
//          },
//          navigation: {
//              nextEl: ".swiper-button-next",
//              prevEl: ".swiper-button-prev"
//          },
//          autoplay: {
//              delay: 2000,
//             disableOnInteraction: true, 
//         },
    
//     });
/*
if ($('.product-recently-viewed__content').find('.product-recently-viewed-card').length === 0) {
  // Hide the entire recently viewed section
  $('.recently-viewed--section').hide();
}*/
document.addEventListener('DOMContentLoaded', function () {
  const content = document.querySelector('.product-recently-viewed__content');
  const cards = content ? content.querySelectorAll('.product-recently-viewed-card') : [];

  if (cards.length === 0) {
    const section = document.querySelector('.recently-viewed--section');
    if (section) {
      section.style.display = 'none';
    }
  }
});




/* ======================= Calculator tool code start from here ======================= */
    var jquery = jQuery;

    



  jquery(document).ready(function () {


    /* === Helper: find outer product row (works with nested tables) === */
      function getProductRow($el) {
        if (!$el || $el.length === 0) return jquery();

        // start from the closest tr
        var $cur = $el.closest('tr');

        // climb up until we find a tr that contains a .product-title
        var safety = 0;
        while ($cur.length && $cur.find('.product-title').length === 0 && safety < 10) {
            $cur = $cur.parent().closest('tr');
            safety++;
        }

        // If not found, return the closest tr anyway
        return $cur.length ? $cur : $el.closest('tr');
    }

      /* --- Utility: parse weight safely --- */
       function readRowWeight($row) {
        $row = getOuterRow($row);
        var dataWeight = $row.find('.weight').data('weight');
        if (typeof dataWeight !== 'undefined' && dataWeight !== null && !isNaN(dataWeight)) {
          return parseFloat(dataWeight);
        }
        var text = ($row.find('.weight').text() || '').trim();
        if (!text) return 0;
        var clean = text.replace(/[^\d\-,.]/g, '').replace(',', '.');
        var n = parseFloat(clean);
        if (!isNaN(n)) return n >= 1000 ? n / 1000 : n;
        return 0;
      }

      /* --- Accordion toggle --- */
       jquery('.accordion-item-header').on('click', function () {
        var $parent = jquery(this).parent();
        var $content = jquery(this).next('.accordion-content');
        var isOpen = $parent.hasClass('active');
        jquery('.accordion-item').removeClass('active');
        jquery('.accordion-content').slideUp(180);
        if (!isOpen) {
          $parent.addClass('active');
          $content.slideDown(180);
        }
        setTimeout(function () {
          // only run assignFirstMaterialActive on outer rows inside this accordion
          var $outerRows = $parent.find('tr').filter(function () { return jquery(this).find('.product-title').length > 0; });
          $outerRows.each(function () { assignFirstMaterialActive(jquery(this)); });
        }, 300);
    });


     function assignFirstMaterialActive($row) {
        $row = getOuterRow($row);
        var $materials = $row.find('.material-options .material');
        if ($materials.length === 0) return;
        if ($materials.filter('.active').length === 0) {
          $materials.removeClass('active');
          var $first = $materials.filter(function() {
            return jquery(this).text().trim() !== '';
          }).first();
          if ($first.length) $first.addClass('active');
        }
    }

      jquery('tr').each(function () {
    assignFirstMaterialActive(getProductRow(jquery(this)));
  });


        /* ----------------------- Utility: get selected material safely ------------------------*/
    function getSelectedMaterial($row) {
    $row = getOuterRow($row);
    var $active = $row.find('.material-options button.active');
    if ($active.length) {
      return $active.data('material') !== undefined ? $active.data('material') : $active.text().trim();
    }
    var $first = $row.find('.material-options button').first();
    return $first.length ? ($first.data('material') !== undefined ? $first.data('material') : $first.text().trim()) : '-';
  }


    // ---------- Helper: find the outer row that contains .product-title ----------
        function findOuterRow(el) {
          var node = el;
          var steps = 0;
          while (node && node !== document && steps < 60) {
            try {
              if (node.querySelector && node.querySelector('.product-title')) {
                return $(node); // return jQuery object of the container that contains .product-title
              }
            } catch(e) { /* ignore odd nodes */ }
            node = node.parentNode;
            steps++;
          }
          // final fallback -> closest tr
          var $closestTr = $(el).closest('tr');
          return $closestTr.length ? $closestTr : $(el);
        }

      /* --- Zustand (Condition) default + click handling --- */
           function initZustandButtons() {
            jQuery(".zustand-options .condition").off("click").on("click", function () {
              let selectedCondition = jQuery(this).data("condition");

              let row = jQuery(this).closest("tr[data-selected-condition]").length 
                          ? jQuery(this).closest("tr[data-selected-condition]") 
                          : jQuery(this).closest("tr").parent().closest("tr");

              row.attr("data-selected-condition", selectedCondition);

              jQuery(this).siblings().removeClass("active");
              jQuery(this).addClass("active");

              console.log("Updated Condition:", selectedCondition);
            });
          }
           initZustandButtons();


      // Helper: get the outer product row (works with nested tables)
       function getOuterRow($el) {
        if (!$el || $el.length === 0) return jquery();
        var $cur = $el.closest('tr');
        var safety = 0;
        while ($cur.length && $cur.find('.product-title').length === 0 && safety < 30) {
          // climb upward: go to parent and find the next ancestor tr
          $cur = $cur.parent().closest('tr');
          safety++;
        }
        // if we found a tr that contains .product-title, return it, otherwise fallback to closest tr
        if ($cur.length && $cur.find('.product-title').length) return $cur;
        return $el.closest('tr');
      }

      // Zustand button click
     jQuery(document).on("click", ".zustand-options .condition:not([disabled])", function () {
        console.log('zustandTD');
          // Optional: check how many buttons exist
          console.log("Total buttons found:", jQuery(".zustand-options .condition").length);

          var $btn = jQuery(this); // clicked button
          var $wrapper = $btn.closest(".zustand-options"); // container of all buttons

          // Reset siblings
          $wrapper.find(".condition").removeClass("active").css("opacity", "0.7");

          // Activate clicked button
          $btn.addClass("active").css("opacity", "1");

          // Save selected condition to the row
          $btn.closest("tr.row_item").attr("data-selected-condition", $btn.data("condition"));
           updateSelection();

          console.log("BUTTON CLICKED:", $btn.data("condition"));
      });
     
  


      // CALL INIT ON PAGE LOAD
      // $(document).ready(function () {
      //   initZustandButtons();
      // });



      /* --- Material button toggles --- */
        jquery(document).on('click', '.material-options button', function () {
        var $btn = jquery(this);
        if ($btn.is(':disabled')) return;
        var $row = getOuterRow($btn);
        $row.find('.material-options button').removeClass('active');
        $btn.addClass('active');
        updateSelection();
      });


       /* ----------------------- When material button clicked ------------------------*/
    // jquery(document).on('click', '.material-options button', function () {
    //   var $btn = jquery(this);
    //   var $row = $btn.closest('tr');

    //   // toggle active state
    //   $btn.closest('.material-options').find('.material').removeClass('active');
    //   $btn.addClass('active');

    //   // update summary instantly if row is checked
    //   if ($row.find('.select-item').is(':checked')) {
    //     updateSelection();
    //   }
    // });

      // Quantity change
          jquery(document).on('input change', '.quantity', function () {
            var $row = getOuterRow(jquery(this));
            updateRowWeight($row);
            updateSelection();
          });

          // Checkbox change
          jquery(document).on('change', '.select-item', function () {
            var $row = getOuterRow(jquery(this));
            toggleButtonsState($row);
            updateSelection();
            setTimeout(function () {
              assignFirstMaterialActive($row);
              updateSelection();
            }, 0);
          });

          // scaff refresh event
          jquery(document).on('scaff:refreshMaterials', function (e, $scope) {
            var $context = $scope || jquery('table');
            var $outerRows = $context.find('tr').filter(function () { return jquery(this).find('.product-title').length > 0; });
            $outerRows.each(function () { assignFirstMaterialActive(jquery(this)); });
            updateSelection();
          });

      /* --- Enable/disable Zustand + Material per row --- */
       function toggleButtonsState($row) {
        $row = getOuterRow($row);
        var isChecked = $row.find('.select-item').is(':checked');
        var $buttons = $row.find('.zustand-options button:not(.cursor-not-allowed), .material-options button, .quantity');
        if (isChecked) {
          $buttons.prop('disabled', false).css({ opacity: 1, pointerEvents: 'auto' });
          // ensure an active exists for Zustand
          if ($row.find('.zustand-options .condition.active').length === 0) {
            var $first = $row.find('.zustand-options .condition:not([disabled])').first();
            if ($first.length) {
              $first.addClass('active').css('opacity', '1');
              $row.attr('data-selected-condition', $first.data('condition'));
            }
          }
        } else {
          $buttons.prop('disabled', true).css({ opacity: 0.5, pointerEvents: 'none' });
          $row.find('.zustand-options .condition, .material-options button').removeClass('active').css('opacity', '0.7');
          $row.removeAttr('data-selected-condition');
        }
        toggleMainButtons();
      }

      // ---------- Toggle main action buttons ----------
      function toggleMainButtons() {
        var $mainButtons = jquery('.button-group button');
        var anyChecked = jquery('.select-item:checked').length > 0;
        $mainButtons.prop('disabled', !anyChecked);
      }

  // ---------- Update per-row total weight ----------
      function updateRowWeight($row) {
        $row = getOuterRow($row);
        var qty = parseFloat($row.find('.quantity').val()) || 1;
        var weightText = ($row.find('.weight').text() || '').replace(/[^\d.]/g, '');
        var weight = parseFloat(weightText) || 0;
        var subtotalWeight = weight * qty;
        $row.find('.total-weight').remove();
        $row.find('.weight').after('<div class="total-weight" style="display:none;"><span class="per-piece">' + weight.toFixed(1) + ' kg/Stück</span></div>');
      }

      /* --- Update summary sidebar --- */
    window.updateSelection = function () {
          jquery('.selected-items').remove(); // clear previous
          var totalCount = 0;
          var totalWeight = 0;
          var $selected = jquery('.select-item:checked');

          if ($selected.length === 0) {
            jquery('.no--items').show();
            jquery('#total-items').text(0);
            jquery('#total-weight').text('0.0');
            jquery('.summary-total, .info-box, .summary-right-main').hide();
            jquery('.next-step-btn, .reset-btn').prop('disabled', true).css({ opacity: 0.5 });
            return;
          } else {
            jquery('.no--items').hide();
            jquery('.summary-total, .info-box, .summary-right-main').show();
            jquery('.next-step-btn, .reset-btn').prop('disabled', false).css({ opacity: 1 });
          }

          $selected.each(function () {
            var $orig = jquery(this);
            var $row = getOuterRow($orig);
            var name = $row.find('.product-title').text().trim() || '-';
            var condition = $row.attr('data-selected-condition') || '-';
            var material = getSelectedMaterial($row) || '-';
            var qty = parseInt($row.find('.quantity').val(), 10) || 1;
            var weightPerUnit = readRowWeight($row);
            var subtotal = weightPerUnit * qty;
            console.log(JSON.stringify($row ));
           

            totalCount += qty;
            totalWeight += subtotal;

            var itemHTML = '<div class="selected-items"><div class="selected-row"><strong>' + jquery('<div>').text(name).html() + '</strong><br>' +
                          qty;
            if (condition !== "-" || material !== "-" ) itemHTML += '× ';
            if (condition !== "-" ) itemHTML += condition;
            if (condition !== "-" && material !== "-" ) itemHTML += ' • ';
            if (material !== "-" ) itemHTML += material;
            itemHTML += '<br><span class="per-piece">' + weightPerUnit.toFixed(1) + ' kg/Stück</span></div><div class="main-weight"><span class="per-piece">' + subtotal.toFixed(1) + 'kg</span></div></div>';

            jquery(itemHTML).insertBefore('.summary-total');
          });

          jquery('#total-items').text(totalCount);
          jquery('#total-weight').text(totalWeight.toFixed(1));
          toggleMainButtons();
  };

      /* --- Step navigation (single place) --- */
      // function goToStep(stepNumber) {
      //   // stepNumber: 1,2,3
      //   jquery('.steps li').removeClass('steps-active step-active'); // remove either class names you may use
      //   // mark only current step as active
      //   jquery('.steps li').eq(stepNumber - 1).addClass('steps-active step-round');



      //   // hide all containers then show the requested one
      //   jquery('.calculator-wrapper, .personal-info-container, .finish-container, .angebot-form').hide();
      //   if (stepNumber === 1) jquery('.calculator-wrapper').show();
      //   if (stepNumber === 2) jquery('.personal-info-container, .angebot-form').show();
      //   if (stepNumber === 3) jquery('.finish-container').show();
      // }



      function goToStep(stepNumber) {
          var $steps = jquery('.steps li');

          // Remove all active indicators
          $steps.removeClass('steps-active step-active');

          // Mark the current step as active
          $steps.eq(stepNumber - 1).addClass('steps-active');

          // --- Step-round progress indicator ---
          // Step 1 is always round
          $steps.removeClass('step-round');
          $steps.eq(0).addClass('step-round');

          // Add "step-round" to previous steps when user progresses
          if (stepNumber > 1) $steps.eq(1).addClass('step-round'); // Step 2 round after step 1 done
          if (stepNumber > 2) $steps.eq(2).addClass('step-round'); // Step 3 round after step 2 done

          // Hide all containers then show current one
          jquery('.calculator-wrapper, .personal-info-container, .finish-container, .angebot-form').hide();
          if (stepNumber === 1) jquery('.calculator-wrapper').show();
          if (stepNumber === 2) jquery('.personal-info-container, .angebot-form').show();
          if (stepNumber === 3) jquery('.finish-container').show();
        }

      /* --- Buttons that move between steps --- */
      // From Step 1 -> Step 2 (Next)
      jquery(document).on('click', '.next-step-btn, .next-btn', function (e) {
        e.preventDefault();
        saveSelectedItemsToStorage();
        goToStep(2);
      });

      // From Step 2 -> Step 1 (Back)
      jquery(document).on('click', '.back-btn', function (e) {
        e.preventDefault();
        goToStep(1);
      });

      // Optional: From Step 3 -> reload to Step 1 (as requested)
      // Use a dedicated button in step 3 with class .finish-next-btn
      jquery(document).on('click', '.finish-next-btn', function (e) {
        e.preventDefault();
        // full reload to reset everything (as you requested)
        location.reload();
      });

      /* --- Save selected items to localStorage --- */
       function saveSelectedItemsToStorage() {
        var selected = [];
        jquery('.select-item:checked').each(function () {
          var $row = getOuterRow(jquery(this));
          var name = $row.find('.product-title').text().trim() || '-';
          var condition = $row.attr('data-selected-condition') || '-';
          var material = getSelectedMaterial($row) || '-';
          var qty = parseInt($row.find('.quantity').val(), 10) || 1;
          var weightPerUnit = readRowWeight($row);
          var totalWeight = (weightPerUnit * qty).toFixed(1);
          selected.push({ name: name, condition: condition, material: material, qty: qty, weight: parseFloat(weightPerUnit.toFixed(1)), totalWeight: totalWeight });
        });
        localStorage.setItem('scaffold_items', JSON.stringify(selected));
      }

      /* --- Build Step 3 review (used after successful submit) --- */
      function buildStep3Review() {
        var items = JSON.parse(localStorage.getItem('scaffold_items') || '[]');
        var formData = JSON.parse(localStorage.getItem('scaffold_form') || '{}');

        jquery('.finish-container .info-grid').html(`
          <p><strong>Name:</strong> ${formData.name || '-'}</p>
          <p><strong>Firma:</strong> ${formData.firma || '-'}</p>
          <p><strong>E-Mail:</strong> ${formData.email || '-'}</p>
          <p><strong>Telefon:</strong> ${formData.telefon || '-'}</p>
          <p><strong>Lieferadresse:</strong> ${formData.adresse || '-'}</p>
          <p><strong>Nachricht / Zusatzinformationen:</strong> ${formData.nachricht || '-'}</p>
        `);
        jquery('#confirm-email').text(formData.email || '');

        var $productArea = jquery('.review-card').last();
        $productArea.empty();

        if (!items.length) {
          $productArea.append('<h4>Ihre Anfrage</h4><p>Keine Artikel ausgewählt.</p>');
          return;
        }

        var totalQty = 0;
        var totalWeight = 0;

        $productArea.append('<div class="review-title"><h4>Ihre Anfrage</h4></div>');
        // Create a wrapper div for the bottom info section
        var $infoWrapper = $('<div class="review-card-btm-info"></div>');
        items.forEach(function (item) {
          totalQty += item.qty;
          totalWeight += parseFloat(item.totalWeight);

          $infoWrapper.append(
            '<div class="item-line">' +
              '<div>' +
                '<strong>' + $('<div>').text(item.name).html() + '</strong><br>' +
                // item.qty + '× ' + item.condition + ' • ' + item.material + '<br>' +
                item.qty + '× ' + item.condition + '<br>' +
                '<span class="per-piece">' + parseFloat(item.weight).toFixed(1) + ' kg/Stück</span>' +
              '</div>' +
              '<div class="item-weight">' + item.totalWeight + ' kg</div>' +
            '</div>'
          );
        });

        $infoWrapper.append(
          '<div class="summary-totals">' +
            '<div class="summary-line"><span class="items-number"><span class="items-number-img"><img src="https://cdn.shopify.com/s/files/1/0730/7830/9186/files/items-number-icon.svg?v=1762507223" alt="items-number-icon"></span>Gesamtanzahl Artikel:</span><span><strong>' + totalQty + '</strong> Stück</span></div>' +
            '<div class="summary-line"><span class="items-number"><span class="items-number-img"><img src="https://cdn.shopify.com/s/files/1/0730/7830/9186/files/weight-icon.svg?v=1762507228" alt="weight-icon"></span>Gesamtgewicht:</span><span><strong>' + totalWeight.toFixed(1) + '</strong> kg</span></div>' +
          '</div>' +
          '<div class="status-box"><p><strong>Status:</strong> Ihr individuelles Angebot wird erstellt und in Kürze an Sie versendet.</p></div>'
        );

        // Finally append everything to the main review card container
          $productArea.append($infoWrapper);
      }



      /* --- Form submit (Step 2) — do NOT reload page --- */
      // Handles your angebot form submission; uses AJAX and then shows Step 3.
      jQuery(document).on('click', '.angebot_form_submit', function (e) {
         e.preventDefault();
          var $form = jQuery("#quoteForm");
          var formEl = $form[0];

        // HTML5 validation
        if (typeof formEl.checkValidity === 'function' && !formEl.checkValidity()) {
          formEl.reportValidity();
          return;
        }

        // Collect and save form to localStorage
        var formData = {
          name: jquery('#name').val() || '',
          firma: jquery('#firma').val() || '',
          email: jquery('#email').val() || '',
          telefon: jquery('#telefon').val() || '',
          adresse: jquery('#adresse').val() || '',
          nachricht: jquery('#nachricht').val() || ''
        };
        localStorage.setItem('scaffold_form', JSON.stringify(formData));

        // Build message (same as before)
        var message = "Anfrage Details:\n\n" +
          "Name: " + formData.name + "\n" +
          "Email: " + formData.email + "\n" +
          "Telefon: " + formData.telefon + "\n" +
          "Nachricht: " + formData.nachricht + "\n\n" +
          "Artikel:\n";

        var storedItems = JSON.parse(localStorage.getItem('scaffold_items') || '[]');
        if (storedItems.length) {
          message += storedItems.map(function(i) {
            return "- " + i.name + " (" + i.condition + ", " + i.material + ") x" + i.qty + " = " + i.totalWeight + "kg";
          }).join("\n");
        } else {
          message += "- Keine Artikel";
        }

        message += "\n\nGesamtanzahl: " + (storedItems.reduce(function (a, i) { return a + i.qty; }, 0)) +
                  "\nGesamtgewicht: " + (storedItems.reduce(function (a, i) { return a + parseFloat(i.totalWeight); }, 0)).toFixed(1) + " kg";

        console.log('message',message);
       jQuery('#contact_body').val(message);
       document.getElementById('quoteForm').submit();
        saveSelectedItemsToStorage();
        buildStep3Review();
        goToStep(3);

       /*
        var fd = new FormData();
        fd.append("form_type", "contact");
        fd.append("contact[name]", formData.name);
        fd.append("contact[email]", formData.email);
        fd.append("contact[phone]", formData.telefon);
        fd.append("contact[body]", message);

        // AJAX POST (keeps on same page)
        jquery.ajax({
          url: '/contact#contact_form',
          method: 'POST',
          data: fd,
          processData: false,
          contentType: false,
          success: function () {
            saveSelectedItemsToStorage(); // ensure items saved
            buildStep3Review();
            goToStep(3);
          },
          error: function () {
            // even on error, show step 3 so user sees confirmation
            saveSelectedItemsToStorage();
            buildStep3Review();
            goToStep(3);
          }
        });*/
      });

      /* --- Reset Button --- */
      jquery(document).on('click', '.reset-btn', function (e) {
        e.preventDefault();
        jquery('.select-item').prop('checked', false);
        jquery('.quantity').val(1);
        jquery('.zustand-options .condition, .material-options button').removeClass('active').css('opacity', '0.7');
        // re-init only outer rows
        var $outerRows = jquery('tr').filter(function () { return jquery(this).find('.product-title').length > 0; });
        $outerRows.each(function () { toggleButtonsState(jquery(this)); });
        updateSelection();
      });

      /* --- back-to-info (explicit reload if needed) --- */
      jquery(document).on('click', '.back-to-info', function (e) {
        e.preventDefault();
        location.reload();
      });

      /* --- Initialize UI on load --- */
      jquery('tr').each(function () { toggleButtonsState(getProductRow(jquery(this))); });
      initZustandButtons();


        // find only real product rows (those containing .product-title)
        var $outerRows = jquery('tr').filter(function () { return jquery(this).find('.product-title').length > 0; });

        // run toggleButtonsState and assignFirstMaterialActive only on outer rows
        $outerRows.each(function () { toggleButtonsState(jquery(this)); });
        $outerRows.each(function () { assignFirstMaterialActive(jquery(this)); });
        initZustandButtons($outerRows);

      // set first accordion open if exists
        var $firstAcc = jquery('.accordion-item').first();
        if ($firstAcc.length) {
          $firstAcc.addClass('active');
          $firstAcc.find('.accordion-content').show();
        }

      // default to step 1
      //goToStep(1);
      updateSelection();

      // expose for debugging if needed
      window.scaffUpdateSelection = updateSelection;

    });
/* ======================= Calculator tool code end here ============================== */



/* ========================================= SCAFF24 SIMPLE ACCORDION (H1 EXCLUDED) ========================================= */
console.log('hi');
document.addEventListener("DOMContentLoaded", function() {
  var container = document.querySelector('.product-description');
  if (!container || container.classList.contains('scaff-processed')) return;
  container.classList.add('scaff-processed');

  var uls = container.querySelectorAll('ul');
  uls.forEach(function(ul){ ul.classList.add('scaff-tech-list'); });

  var accordionWrapper = document.createElement('div');
  accordionWrapper.className = 'scaff-accordions-wrapper';

  var introWrapper = document.createElement('div');
  introWrapper.className = 'product-intro rte';
  introWrapper.style.marginBottom = '25px';

  var currentDetails = null;
  var currentContent = null;
  var nodes = Array.from(container.children);

  nodes.forEach(function(node) {
    var tag = node.tagName;

    if (tag === 'H1') {
       introWrapper.appendChild(node);
       return; 
    }

    if (['H2','H3','H4','H5','H6'].includes(tag)) {
        if (currentDetails) {
            currentDetails.appendChild(currentContent);
            accordionWrapper.appendChild(currentDetails);
        }
        currentDetails = document.createElement('details');
        currentDetails.className = 'scaff-accordion';
        var summary = document.createElement('summary');
        summary.className = 'scaff-accordion-header';
        summary.innerHTML = node.innerHTML;
        currentDetails.appendChild(summary);
        currentContent = document.createElement('div');
        currentContent.className = 'scaff-accordion-content rte';
    } else {
        if (currentDetails) {
            currentContent.appendChild(node);
        } else {
            introWrapper.appendChild(node);
        }
    }
  });

  if (currentDetails) {
      currentDetails.appendChild(currentContent);
      accordionWrapper.appendChild(currentDetails);
  }

  container.innerHTML = '';
  if (introWrapper.childNodes.length > 0) container.appendChild(introWrapper);
  if (accordionWrapper.childNodes.length > 0) container.appendChild(accordionWrapper);

  setTimeout(function() {
    var listItems = document.querySelectorAll('.scaff-tech-list li');
    listItems.forEach(function(li) {
      if (!li.querySelector('span[style]') && li.innerText.includes(':')) {
        var parts = li.innerText.split(':');
        if (parts.length >= 2) {
          var label = parts[0].trim();
          var value = parts.slice(1).join(':').trim();
          li.innerHTML = '<span style="font-weight:700; min-width:40%; display:inline-block;">' + label + '</span><span>' + value + '</span>';
        }
      }
    });
  }, 50);
});

// SCAFF24: Predictive Search auch nach Artikelnummer (SKU) suchen lassen.
// Die Predictive Search API durchsucht standardmaessig nur title, product_type,
// variants.title, vendor (kein SKU). Die volle /search-Ergebnisseite findet SKUs
// bereits automatisch, die Live-Vorschlagsliste (empire.min.js -> /search/suggest)
// nicht. Da empire.min.js Vendor-Code ist, hier stattdessen window.fetch patchen
// und variants.sku im fields-Parameter ergaenzen, bevor der Request raus geht.
(function () {
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    if (typeof input === 'string' && input.indexOf('/search/suggest') !== -1 && input.indexOf('options%5Bfields%5D') === -1) {
      var separator = input.indexOf('?') === -1 ? '?' : '&';
      var fieldsParam = 'resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Cvendor%2Cvariants.sku';
      return originalFetch(input + separator + fieldsParam, init);
    }
    return originalFetch(input, init);
  };
})();

// SCAFF24: Artikelnummer per Klick kopieren.
// [data-copy-sku] (.scaff-sku-chip) wrapt Label + [data-product-sku]-Span
// (siehe snippets/product.liquid). Leere SKUs sind per .product-sku--empty
// ausgeblendet, daher hier nichts kopieren, wenn diese Klasse gesetzt ist.
// Icon wechselt per .is-copied-Klasse von Kopie- auf Haken-Symbol (siehe CSS).
document.addEventListener('click', function (event) {
  var wrapper = event.target.closest && event.target.closest('[data-copy-sku]');
  if (!wrapper || wrapper.classList.contains('product-sku--empty')) return;
  var skuEl = wrapper.querySelector('[data-product-sku]');
  if (!skuEl || !skuEl.textContent.trim() || !navigator.clipboard) return;
  navigator.clipboard.writeText(skuEl.textContent.trim()).then(function () {
    wrapper.classList.add('is-copied');
    setTimeout(function () {
      wrapper.classList.remove('is-copied');
    }, 1500);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Fallback-Pfad (siehe scaffAjaxApplyUrl): falls die AJAX-Anfrage
  // fehlschlaegt, wird ganz normal neu navigiert. Damit man dann wenigstens
  // nicht am Seitenanfang landet, merken wir uns den Filter vorher und
  // scrollen nach dem Reload zu seiner Filtergruppe zurueck.
  try {
    var scaffScrollParam = sessionStorage.getItem('scaffRangeScrollTo');
    if (scaffScrollParam) {
      sessionStorage.removeItem('scaffRangeScrollTo');
      var scaffScrollToFilter = function () {
        var target = document.querySelector('[data-scaff-range-filter][data-param-name="' + scaffScrollParam + '"]');
        if (!target) return;
        var group = target.closest('[data-filter-group]') || target;
        var rect = group.getBoundingClientRect();
        window.scrollTo(0, window.pageYOffset + rect.top - 120);
      };
      scaffScrollToFilter();
      setTimeout(scaffScrollToFilter, 300);
    }
  } catch (e) {}

  // SCAFF24: gemeinsame AJAX-Anwendung fuer jede Filter-Aktion, die auf der
  // Kollektionsseite nur eine Section (Filter-Sidebar + Produktraster) neu
  // rendern soll: Regler-Anwenden UND Entfernen eines aktiven Filter-Tags
  // ("x") nutzen beide diese Funktion, damit keine der beiden Aktionen die
  // Seite sichtbar neu laedt/an den Seitenanfang springt. Ueber Shopifys
  // Section-Rendering-API (?section_id=) + history.pushState statt
  // window.location, gefolgt von denselben shopify:section:load/unload-
  // Events, die der Theme-Editor fuer Live-Updates nutzt (siehe class
  // Sections in empire.js) - dadurch reinitialisiert sich das native
  // Filter-/Sortier-JS in der Section automatisch mit.
  // Zaehler gegen ueberholende Antworten. Ohne ihn kann sich Folgendes
  // ergeben: Anfrage A und B laufen gleichzeitig (beim Ziehen am Regler wird
  // 320 ms nach der letzten Bewegung gefiltert, ein zweiter Zug schickt B los,
  // waehrend A noch unterwegs ist). Kommt A zuerst zurueck, tauscht A die
  // Section aus. Bs sectionWrapper zeigt dann auf einen abgehaengten Knoten,
  // sein replaceWith ist ein stiller Leerlauf - sein pushState laeuft aber.
  // Ergebnis: Raster und Reglerstellung stammen aus A, die URL aus B. Wer
  // die URL neu laedt oder teilt, sieht etwas anderes als auf dem Schirm.
  var scaffAjaxSeq = 0;

  // Zieht eine Anzeige AUSSERHALB des getauschten Teilstuecks textlich nach.
  function scaffSyncText(altRoot, neuRoot, sel) {
    var a = altRoot.querySelector(sel);
    var b = neuRoot.querySelector(sel);
    if (a && b) a.textContent = b.textContent;
  }

  // Zieht die Filterspalte nach, OHNE ihre Knoten zu ersetzen.
  // Beim Teil-Tausch bleibt die Spalte absichtlich stehen, damit der Regler
  // unter dem Finger nicht verschwindet. Damit blieben aber auch ihre Zahlen
  // und Ziel-Adressen auf dem Stand von vorher: die Zustandskarte sagte noch
  // "62 Artikel", waehrend im Raster schon eine Laengen-Spanne wirkte, und ein
  // Klick darauf wendete eine veraltete Kombination an. Deshalb hier Text,
  // Zustand und href je Option gezielt aktualisieren.
  function scaffSyncFacetSidebar(altRoot, neuRoot) {
    var altSpalte = altRoot.querySelector('.scaff-facets');
    var neuSpalte = neuRoot.querySelector('.scaff-facets');
    if (!altSpalte || !neuSpalte) return;

    function schluessel(el) {
      var grp = el.closest('[data-scaff-group]');
      return (grp ? grp.getAttribute('data-param') : '') + '|' + (el.getAttribute('data-scaff-value') || '');
    }

    var neuOpt = {};
    Array.prototype.forEach.call(neuSpalte.querySelectorAll('[data-scaff-facet-link]'), function (el) {
      neuOpt[schluessel(el)] = el;
    });

    Array.prototype.forEach.call(altSpalte.querySelectorAll('[data-scaff-facet-link]'), function (el) {
      var neu = neuOpt[schluessel(el)];
      if (!neu) return;
      el.setAttribute('href', neu.getAttribute('href'));
      el.setAttribute('aria-pressed', neu.getAttribute('aria-pressed') || 'false');
      el.className = neu.className;
      ['.scaff-card__count', '.scaff-pill__count', '.scaff-check__count'].forEach(function (sel) {
        var a = el.querySelector(sel), b = neu.querySelector(sel);
        if (a && b) a.textContent = b.textContent;
      });
    });

    // Zusammenfassungen der Gruppen, aber NICHT die der Regler: die schreibt
    // das Regler-JS beim Ziehen live mit, ein Ueberschreiben wuerde die Anzeige
    // auf den Stand des Servers zuruecksetzen.
    Array.prototype.forEach.call(altSpalte.querySelectorAll('[data-scaff-group]'), function (grp) {
      if (grp.querySelector('[data-scaff-range]')) return;
      var param = grp.getAttribute('data-param');
      var neuGrp = neuSpalte.querySelector('[data-scaff-group][data-param="' + param + '"]');
      if (!neuGrp) return;
      var a = grp.querySelector('[data-scaff-group-sum]'), b = neuGrp.querySelector('[data-scaff-group-sum]');
      if (a && b) a.textContent = b.textContent;
    });

    var altReset = altSpalte.querySelector('[data-scaff-facets-reset]');
    var neuReset = neuSpalte.querySelector('[data-scaff-facets-reset]');
    if (altReset && neuReset) altReset.setAttribute('href', neuReset.getAttribute('href'));
  }

  // opts: { partial, quiet, replaceState, skipPush }
  //   partial      CSS-Auswahl des Teilstuecks, das allein getauscht wird.
  //                Alles ausserhalb bleibt derselbe DOM-Knoten. Gedacht fuer
  //                das Filtern WAEHREND man den Regler festhaelt: wird die
  //                ganze Section ersetzt, verschwindet der Regler unter dem
  //                Finger und der Zug reisst ab.
  //   quiet        kein Ladeschleier (der blitzt sonst bei jedem
  //                Zwischenschritt eines Zugs auf)
  //   replaceState Adresse ersetzen statt einen History-Eintrag anzulegen
  //   skipPush     Adresse gar nicht anfassen (Ruecksprung per popstate)
  // ===========================================================================
  // SCAFF24: Filter-Tracking
  //
  // Warum: Die Filterbedienung war bis hierher in KEINEM System messbar. Im
  // Theme gab es null dataLayer-Aufrufe, und Shopify Analytics wirft den
  // Query-String weg (landing_page_path und landing_page_url liefern die URL
  // ohne ?filter.*). Es liess sich also weder sagen, wie oft gefiltert wird,
  // noch welche Facette gezogen wird, noch ob Filternde besser konvertieren.
  //
  // Hier haengt das Tracking an genau EINER Stelle: scaffAjaxApplyUrl ist der
  // gemeinsame Weg fuer Regler, Pillen, Checkboxen, Zustandskarten, die
  // Chip-Leiste und das Zuruecksetzen. Sortierung und Blaettern laufen
  // ebenfalls durch die Funktion, werden aber ueber den Vergleich der
  // filter.*-Parameter herausgehalten: aendert sich kein Filter, gibt es kein
  // Ereignis.
  //
  // Alles ist in try/catch gekapselt. Ein Fehler im Tracking darf die
  // Filterung nicht anhalten.
  // ===========================================================================
  function scaffFilterParams(url) {
    var out = {};
    try {
      url.searchParams.forEach(function (wert, schluessel) {
        if (schluessel.indexOf('filter.') !== 0) return;
        if (!out[schluessel]) out[schluessel] = [];
        out[schluessel].push(wert);
      });
    } catch (e) {}
    return out;
  }

  // Kurzname der Facette: 'filter.p.m.custom.zustand' -> 'custom.zustand',
  // 'filter.v.price.gte' -> 'price'. Das liest sich in GA4 deutlich besser als
  // der volle Parametername.
  function scaffFacetName(param) {
    if (param.indexOf('filter.p.m.') === 0) return param.slice(11);
    if (param.indexOf('filter.v.price') === 0) return 'price';
    return param.replace(/^filter\.(p|v)\./, '');
  }

  function scaffDataLayer(nutzlast) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(nutzlast);
    } catch (e) {}
  }

  // Vergleicht die filter.*-Parameter vor und nach der Anwendung und schickt
  // pro veraenderter Facette ein Ereignis. Die Trefferzahl kommt aus dem
  // frisch gerenderten Abschnitt, deshalb wird sie erst nach dem Austausch
  // nachgetragen.
  function scaffTrackFilter(vorher, nachher, neuerAbschnitt) {
    try {
      var alt = scaffFilterParams(vorher);
      var neu = scaffFilterParams(nachher);
      var alleParams = {};
      Object.keys(alt).forEach(function (k) { alleParams[k] = 1; });
      Object.keys(neu).forEach(function (k) { alleParams[k] = 1; });

      var treffer = null;
      if (neuerAbschnitt) {
        var zaehler = neuerAbschnitt.querySelector('.scaff-cro__count strong');
        if (zaehler) {
          var z = parseInt(zaehler.textContent.replace(/\D/g, ''), 10);
          if (!isNaN(z)) treffer = z;
        }
      }

      var aktiveFacetten = Object.keys(neu).length;
      var etwasGesendet = false;

      Object.keys(alleParams).forEach(function (param) {
        var a = (alt[param] || []).slice().sort().join('|');
        var n = (neu[param] || []).slice().sort().join('|');
        if (a === n) return;

        var altListe = alt[param] || [];
        var neuListe = neu[param] || [];
        var dazu = neuListe.filter(function (w) { return altListe.indexOf(w) === -1; });
        var weg = altListe.filter(function (w) { return neuListe.indexOf(w) === -1; });

        etwasGesendet = true;
        scaffDataLayer({
          event: 'filter_anwenden',
          filter_facette: scaffFacetName(param),
          filter_param: param,
          filter_aktion: neuListe.length === 0 ? 'entfernt' : (altListe.length === 0 ? 'gesetzt' : 'geaendert'),
          filter_werte: neuListe.join(', '),
          filter_werte_dazu: dazu.join(', '),
          filter_werte_weg: weg.join(', '),
          filter_werte_anzahl: neuListe.length,
          filter_facetten_aktiv: aktiveFacetten,
          filter_treffer: treffer,
          filter_pfad: nachher.pathname
        });
      });

      // Zuruecksetzen: vorher waren Filter aktiv, jetzt keine mehr. Die
      // Schleife oben meldet dann pro Facette ein 'entfernt', zusaetzlich ist
      // aber das Ereignis selbst interessant.
      if (Object.keys(alt).length > 0 && aktiveFacetten === 0) {
        scaffDataLayer({
          event: 'filter_zurueckgesetzt',
          filter_facetten_vorher: Object.keys(alt).length,
          filter_treffer: treffer,
          filter_pfad: nachher.pathname
        });
      }

      return etwasGesendet;
    } catch (e) {
      return false;
    }
  }

  // Einstieg auf einer bereits gefilterten Adresse, etwa aus einem Menuelink,
  // einem Lesezeichen oder der Suche. Ohne dieses Ereignis fehlt genau der
  // Teil der Filternutzung, der nicht im Shop selbst entsteht.
  (function scaffTrackFilterEinstieg() {
    try {
      var params = scaffFilterParams(new URL(window.location.href));
      var facetten = Object.keys(params);
      if (facetten.length === 0) return;
      scaffDataLayer({
        event: 'filter_einstieg',
        filter_facetten: facetten.map(scaffFacetName).join(', '),
        filter_facetten_aktiv: facetten.length,
        filter_pfad: window.location.pathname
      });
    } catch (e) {}
  })();

  function scaffAjaxApplyUrl(url, referenceEl, scrollRestoreParam, opts) {
    var mySeq = ++scaffAjaxSeq;
    // Adresse VOR der Anwendung festhalten, sonst ist der Vergleich nach dem
    // pushState wertlos.
    var scaffUrlVorher = null;
    try { scaffUrlVorher = new URL(window.location.href); } catch (e) {}
    if (opts === true) opts = { skipPush: true };
    if (!opts || typeof opts !== 'object') opts = {};
    function fallbackFullPage() {
      try {
        if (scrollRestoreParam) sessionStorage.setItem('scaffRangeScrollTo', scrollRestoreParam);
      } catch (e) {}
      window.location.href = url.toString();
    }

    var sectionWrapper = referenceEl.closest('.shopify-section');
    var sectionId = sectionWrapper && sectionWrapper.id ? sectionWrapper.id.replace('shopify-section-', '') : null;
    if (!sectionWrapper || !sectionId || !window.fetch) {
      fallbackFullPage();
      return;
    }

    var fetchUrl = new URL(url.toString());
    fetchUrl.searchParams.set('section_id', sectionId);

    var partialSel = opts.partial || null;
    var loadingEl = sectionWrapper;
    if (partialSel) {
      var vorhanden = sectionWrapper.querySelector(partialSel);
      if (vorhanden) loadingEl = vorhanden;
      else partialSel = null;   // Teilstueck nicht da, dann eben komplett
    }
    if (!opts.quiet) loadingEl.classList.add('scaff-section-loading');

    fetch(fetchUrl.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('scaff ajax: section fetch failed');
        return response.text();
      })
      .then(function (html) {
        if (mySeq !== scaffAjaxSeq) return;   // von einer neueren Anfrage ueberholt
        var temp = document.createElement('div');
        temp.innerHTML = html.trim();
        var newSection = temp.firstElementChild;
        if (!newSection) throw new Error('scaff ajax: empty section response');
        function adresse() {
          if (opts.skipPush) return;
          if (opts.replaceState) history.replaceState({ scaffFilter: true }, '', url.toString());
          else history.pushState({ scaffFilter: true }, '', url.toString());
        }

        var altTeil = partialSel ? sectionWrapper.querySelector(partialSel) : null;
        var neuTeil = partialSel ? newSection.querySelector(partialSel) : null;

        if (altTeil && neuTeil) {
          altTeil.replaceWith(neuTeil);
          // Der Zaehler im Fuss des mobilen Filter-Panels liegt AUSSERHALB des
          // getauschten Teilstuecks. Nur seinen Text nachziehen, damit der
          // Knoten selbst unberuehrt bleibt.
          scaffSyncText(sectionWrapper, newSection, '.scaff-facets__apply');
          scaffSyncFacetSidebar(sectionWrapper, newSection);
          adresse();
          // Bewusst KEINE section:load/unload-Events: der unberuehrte Teil
          // wuerde sonst ein zweites Mal initialisiert. Das Teilstueck bleibt
          // fuer die Dauer des Zugs ohne Theme-JS; beim Loslassen folgt der
          // vollstaendige Tausch und stellt alles her.
          return;
        }

        sectionWrapper.dispatchEvent(new CustomEvent('shopify:section:unload', {
          bubbles: true,
          detail: { sectionId: sectionId }
        }));
        sectionWrapper.replaceWith(newSection);
        adresse();
        newSection.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: { sectionId: sectionId }
        }));
        // Bewusst abgeschirmt: der Austausch ist an dieser Stelle schon
        // erfolgt. Wuerde die Neu-Initialisierung hier werfen, landete der
        // Fehler im catch unten und riss einen vollen Seiten-Reload hoch -
        // obwohl der neue Stand bereits korrekt auf dem Schirm steht.
        try { scaffInitRangeFilters(newSection); } catch (e) {}
        // SCAFF24 Filter-Tracking. Bewusst NUR hier und nicht im Teilstueck-
        // Zweig darueber: das Teilstueck wird waehrend eines Reglerzugs
        // mehrfach pro Sekunde getauscht, das waeren Dutzende Ereignisse fuer
        // eine Bewegung. Beim Loslassen folgt immer der vollstaendige Tausch,
        // also genau ein Ereignis pro abgeschlossener Bedienung.
        if (scaffUrlVorher) scaffTrackFilter(scaffUrlVorher, url, newSection);
      })
      .catch(function () {
        // Eine veraltete Fehlantwort darf keinen vollen Reload ausloesen, sonst
        // reisst sie den bereits angezeigten neueren Stand wieder weg.
        if (mySeq !== scaffAjaxSeq) return;
        fallbackFullPage();
      });
  }

  // SCAFF24: fuer die CRO-Filterspalte (assets/scaff-facets.js) nach aussen
  // geben. Die Funktion ist hier im DOMContentLoaded-Closure definiert und
  // waere sonst von einer zweiten Datei nicht erreichbar - die Logik
  // (Section-Rendering + pushState + shopify:section:load) soll aber nicht
  // dupliziert werden.
  window.scaffAjaxApplyUrl = scaffAjaxApplyUrl;

  // Sortierung ohne Seitensprung.
  // Das Theme setzt in _changeSorting einfach window.location.search und laedt
  // damit die komplette Seite neu - die Ansicht springt dabei nach oben, man
  // verliert seine Position im Raster. Wir fangen das in der CAPTURE-Phase ab,
  // also bevor der Handler am Element selbst dran ist, und rendern nur die
  // Section neu. Greift fuer das Auswahlfeld auf dem Desktop und fuer die
  // Knopfliste im mobilen Sortier-Dialog.
  function scaffSortAnwenden(value) {
    var ref = document.querySelector('[data-productgrid-outer]');
    if (!ref) return false;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    scaffAjaxApplyUrl(url, ref, null, {});
    return true;
  }

  document.addEventListener('change', function (ev) {
    var sel = ev.target && ev.target.closest ? ev.target.closest('[data-productgrid-trigger-sort]') : null;
    if (!sel || !sel.value) return;
    // Erst pruefen, ob wir es koennen. Sonst lieber den Theme-Handler lassen,
    // als die Sortierung ganz zu verschlucken.
    if (!document.querySelector('[data-productgrid-outer]')) return;
    ev.preventDefault();
    ev.stopPropagation();
    scaffSortAnwenden(sel.value);
  }, true);

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('[data-productgrid-trigger-sort-button]') : null;
    if (!btn || !btn.value) return;
    if (!document.querySelector('[data-productgrid-outer]')) return;
    ev.preventDefault();
    ev.stopPropagation();
    scaffSortAnwenden(btn.value);
  }, true);

  // Zurueck-Taste. pushState aendert die Adresse, aber nicht den Inhalt: ohne
  // das Folgende steht nach einem Klick auf "zurueck" die alte Filter-URL in
  // der Leiste, angezeigt bleibt aber das zuletzt gefilterte Raster.
  // Der Einstiegs-Eintrag wird mitmarkiert, damit auch der Schritt zurueck auf
  // den ungefilterten Stand erkannt wird. Fremde History-Eintraege haben die
  // Markierung nicht und werden nicht angefasst.
  if (document.querySelector('[data-productgrid-outer]')) {
    try {
      history.replaceState({ scaffFilter: true }, '', window.location.href);
    } catch (e) {}
    window.addEventListener('popstate', function (ev) {
      if (!ev.state || !ev.state.scaffFilter) return;
      var ref = document.querySelector('[data-productgrid-items]') ||
                document.querySelector('[data-productgrid-outer]');
      if (!ref) return;
      scaffAjaxApplyUrl(new URL(window.location.href), ref, null, { skipPush: true });
    });
  }

  // Entfernen eines aktiven Filter-Tags ("x") lief bisher ueber den
  // nativen Klick-Handler von FacetedFilterCollection (empire.js), der
  // direkt auf dem Link sitzt und per window.location.search navigiert.
  // Ein Capture-Listener auf document faengt den Klick VOR diesem nativen
  // Handler ab (Capture-Phase laeuft vor der Ziel-Phase), verhindert damit
  // dessen Ausfuehrung komplett und ersetzt sie durch dieselbe AJAX-Logik
  // wie beim Regler. Bewusst nur auf .active-filter-group__item begrenzt
  // (nicht jeden [data-filter-input] siteweit, das waere z.B. auch jede
  // Checkbox-Filter-Option) - Checkbox-Filter navigieren also weiterhin
  // wie bisher per Reload, das war nicht Teil dieser Anfrage.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.active-filter-group__item[data-filter-input]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    event.preventDefault();
    event.stopPropagation();
    scaffAjaxApplyUrl(new URL(href, window.location.href), link, null);
  }, true);

  // SCAFF24: Von/Bis-Regler fuer Quadratmeter/Gerüstlänge/Feldlänge/Arbeitshöhe.
  // Shopify liefert fuer Metafeld-Filter nur den Typ 'list' (Einzelwert-Mehrfachauswahl),
  // kein natives gte/lte wie beim echten Preisfilter. Der Regler waehlt daher beim
  // Anwenden alle Einzelwerte aus dem gewaehlten Bereich aus und haengt sie als
  // wiederholte gleichnamige Query-Parameter an (das ist exakt das Format, das man
  // bekommt, wenn man mehrere Checkboxen der Liste manuell anklicken wuerde).
  // SCAFF24: Zahl in deutscher Schreibweise (Komma) inkl. Einheit. Nur fuer
  // die Anzeige - der tatsaechliche <input>-Wert und die Query-Parameter
  // bleiben immer numerisch mit Punkt.
  function scaffFormatNumber(n, unit) {
    var deNumber = String(Math.round(n * 100) / 100).replace('.', ',');
    return unit ? deNumber + ' ' + unit : deNumber;
  }

  // SCAFF24: naechstgelegener verfuegbarer Wert zu einer freien
  // Reglerposition. Bewusst NICHT ab- oder aufrunden: bei Werten 2 / 2,57 / 3
  // soll die Position 2,5 auf 2,57 einrasten (Abstand 0,07) und nicht auf 2
  // (Abstand 0,5). Bei genau gleichem Abstand gewinnt der groessere Wert -
  // ein zu grosses Geruest laesst sich einsetzen, ein zu kleines nicht.
  // candidates muss numerisch aufsteigend sortiert sein.
  function scaffNearestValue(candidates, target) {
    var best = candidates[0];
    var bestDist = Math.abs(candidates[0] - target);
    for (var i = 1; i < candidates.length; i++) {
      var dist = Math.abs(candidates[i] - target);
      // <= statt <: bei Gleichstand uebernimmt der spaetere (= groessere) Wert
      if (dist <= bestDist) {
        best = candidates[i];
        bestDist = dist;
      }
    }
    return best;
  }

  var SCAFF_RANGE_NOTE_KEY = 'scaffRangeSnapNote';

  function scaffClearRangeNote() {
    try {
      sessionStorage.removeItem(SCAFF_RANGE_NOTE_KEY);
    } catch (e) {}
  }

  // SCAFF24: Vermerk "gewuenschter Wert nicht verfuegbar, das ist die
  // naechstpassende Groesse". Die Notiz entsteht beim Anwenden des Reglers,
  // angezeigt wird sie erst im danach neu gerenderten Markup - deshalb laeuft
  // sie ueber sessionStorage (ueberlebt den AJAX-Section-Tausch genauso wie
  // den Fallback-Reload, gleiches Muster wie scaffRangeScrollTo oben).
  function scaffRenderRangeNote(root) {
    root.querySelectorAll('[data-scaff-range-note]').forEach(function (el) {
      el.remove();
    });

    var note = null;
    try {
      note = JSON.parse(sessionStorage.getItem(SCAFF_RANGE_NOTE_KEY));
    } catch (e) {}
    if (!note || !note.param) return;

    // Notiz gilt nur fuer die Seite, auf der sie entstanden ist.
    if (note.path && note.path !== window.location.pathname) {
      scaffClearRangeNote();
      return;
    }

    // Konsistenzpruefung: die eingerastete Spanne muss noch exakt die aktive
    // Spanne dieses Filters sein. Sobald der Nutzer das Badge entfernt, "Alle
    // loeschen" klickt oder anders filtert, ist die Notiz veraltet.
    var container = root.querySelector('[data-scaff-range-filter][data-param-name="' + note.param + '"]');
    if (!container) {
      scaffClearRangeNote();
      return;
    }
    var activeNums;
    try {
      activeNums = JSON.parse(container.dataset.values)
        .filter(function (v) { return v.active; })
        .map(function (v) { return parseFloat(v.value); })
        .filter(function (n) { return !isNaN(n); });
    } catch (e) {
      scaffClearRangeNote();
      return;
    }
    if (!activeNums.length) {
      scaffClearRangeNote();
      return;
    }
    var stillMatches =
      Math.abs(Math.min.apply(null, activeNums) - note.snapFrom) < 0.0001 &&
      Math.abs(Math.max.apply(null, activeNums) - note.snapTo) < 0.0001;
    if (!stillMatches) {
      scaffClearRangeNote();
      return;
    }

    var unit = note.unit || '';
    var requestedText;
    var snappedText;
    var suggestionLabel;
    // Zieht man ein Handle ueber das andere, schiebt updateVisuals das zweite
    // mit - dann sind beide Rohwerte identisch und "2,3 bis 2,3" waere Unsinn.
    // In dem Fall die Einzelform verwenden.
    var isSpan = note.fromOff && note.toOff && Math.abs(note.rawFrom - note.rawTo) > 0.0001;
    if (isSpan) {
      requestedText = scaffFormatNumber(note.rawFrom, '') + ' bis ' + scaffFormatNumber(note.rawTo, unit);
      snappedText = scaffFormatNumber(note.snapFrom, '') + ' bis ' + scaffFormatNumber(note.snapTo, unit);
      suggestionLabel = 'Nächstpassende Spanne:';
    } else if (note.fromOff) {
      requestedText = scaffFormatNumber(note.rawFrom, unit);
      snappedText = scaffFormatNumber(note.snapFrom, unit);
      suggestionLabel = 'Nächstpassende Größe:';
    } else {
      requestedText = scaffFormatNumber(note.rawTo, unit);
      snappedText = scaffFormatNumber(note.snapTo, unit);
      suggestionLabel = 'Nächstpassende Größe:';
    }

    var noteEl = document.createElement('div');
    noteEl.className = 'scaff-range-note';
    noteEl.setAttribute('data-scaff-range-note', '');
    noteEl.setAttribute('role', 'status');

    var textEl = document.createElement('span');
    textEl.className = 'scaff-range-note__text';
    textEl.textContent =
      (note.label ? note.label + ' ' : '') + requestedText + ' ist nicht verfügbar. ' + suggestionLabel;

    var valueEl = document.createElement('span');
    valueEl.className = 'scaff-range-note__value';
    valueEl.textContent = snappedText;

    noteEl.appendChild(textEl);
    noteEl.appendChild(valueEl);

    // SCAFF24: zweite Option, wenn nach UNTEN eingerastet wurde. Wer mindestens
    // die Wunschgroesse braucht, ist mit dem kleineren Wert nicht bedient.
    // Bei einer Punktauswahl (from == to) wird auf die groessere Groesse
    // gewechselt, bei einer echten Spanne wird sie nach oben erweitert - sonst
    // wuerfe der Klick die untere Haelfte der Auswahl weg.
    if (note.upValue !== null && note.upValue !== undefined && !isNaN(note.upValue)) {
      var upBtn = document.createElement('button');
      upBtn.type = 'button';
      upBtn.className = 'scaff-range-note__up';
      upBtn.setAttribute('data-scaff-range-note-up', '');
      upBtn.textContent =
        'Mindestens ' + scaffFormatNumber(note.rawTo, unit) + ' nötig? ' +
        scaffFormatNumber(note.upValue, unit) + ' anzeigen';
      upBtn.addEventListener('click', function () {
        var isPoint = Math.abs(note.snapFrom - note.snapTo) < 0.0001;
        var newFrom = isPoint ? note.upValue : note.snapFrom;
        var newTo = note.upValue;
        var vals;
        try {
          vals = JSON.parse(container.dataset.values);
        } catch (e) {
          return;
        }
        var url = new URL(window.location.href);
        url.searchParams.delete(note.param);
        vals.forEach(function (v) {
          var n = parseFloat(v.value);
          if (!isNaN(n) && n >= newFrom - 0.0001 && n <= newTo + 0.0001) {
            url.searchParams.append(note.param, v.value);
          }
        });
        // Der Nutzer hat entschieden, der Vermerk hat sich damit erledigt.
        scaffClearRangeNote();
        noteEl.remove();
        scaffAjaxApplyUrl(url, container, note.param);
      });
      noteEl.appendChild(upBtn);
    }

    // Direkt ueber die Leiste mit den aktiven Filter-Badges, damit Vermerk und
    // das dazugehoerige Badge zusammen gelesen werden. Als Geschwister davor,
    // nicht als Kind: die Leiste selbst ist ein einzeilig scrollender
    // Flex-Container, darin wuerde der Vermerk neben den Badges landen und
    // mit ihnen aus dem Sichtfeld scrollen.
    var badgeBar = root.querySelector('.productgrid--filters.custom_filter') ||
      root.querySelector('.productgrid--filters');
    if (badgeBar && badgeBar.parentNode) {
      badgeBar.parentNode.insertBefore(noteEl, badgeBar);
      return;
    }
    var productCount = root.querySelector('.scaff-product-count');
    if (productCount && productCount.parentNode) {
      productCount.parentNode.insertBefore(noteEl, productCount);
      return;
    }
    container.insertBefore(noteEl, container.firstChild);
  }

  function scaffInitRangeFilters(root) {
    scaffRenderRangeNote(root);

    root.querySelectorAll('[data-scaff-range-filter]').forEach(function (container) {
      if (container.dataset.scaffRangeBound) return;
      container.dataset.scaffRangeBound = 'true';

      var paramName = container.dataset.paramName;
      var unit = container.dataset.unit || '';
      var values;
      try {
        values = JSON.parse(container.dataset.values);
      } catch (e) {
        return;
      }
      var nums = values
        .map(function (v) { return parseFloat(v.value); })
        .filter(function (n) { return !isNaN(n); });
      if (!nums.length) return;

      var dataMin = Math.min.apply(null, nums);
      var dataMax = Math.max.apply(null, nums);
      if (dataMin === dataMax) return;

      // Einrast-Kandidaten: nur Werte mit Treffern (aktive Werte zaehlen immer
      // mit, ihr count kann in der laufenden Filterkombination 0 sein).
      // Aufsteigend sortiert und dedupliziert, weil scaffNearestValue das
      // fuer den Gleichstand-Tiebreak voraussetzt.
      var snapCandidates = values
        .filter(function (v) { return v.active || (v.count === undefined ? true : v.count > 0); })
        .map(function (v) { return parseFloat(v.value); })
        .filter(function (n) { return !isNaN(n); });
      if (!snapCandidates.length) snapCandidates = nums.slice();
      snapCandidates = snapCandidates
        .sort(function (a, b) { return a - b; })
        .filter(function (n, i, arr) { return i === 0 || n !== arr[i - 1]; });

      // Ab wann ist eine Abweichung einen Vermerk wert: 0,5 % der Gesamtspanne,
      // mindestens 0,05 (5 cm bei Meter-Feldern). Ohne Schwelle wuerde bei
      // Feldern mit sehr vielen dicht liegenden Werten (Quadratmeter) fast
      // jeder Reglerzug einen Hinweis erzeugen, obwohl die Abweichung
      // praktisch nicht wahrnehmbar ist.
      var noteThreshold = Math.max(0.05, (dataMax - dataMin) * 0.005);

      var fromInput = container.querySelector('[data-scaff-range-from]');
      var toInput = container.querySelector('[data-scaff-range-to]');
      var readoutFrom = container.querySelector('[data-scaff-range-readout-from]');
      var readoutTo = container.querySelector('[data-scaff-range-readout-to]');
      var scaleMin = container.querySelector('[data-scaff-range-scale-min]');
      var scaleMax = container.querySelector('[data-scaff-range-scale-max]');
      var trackActive = container.querySelector('[data-scaff-range-track-active]');

      function formatVal(n) {
        return scaffFormatNumber(n, unit);
      }

      [fromInput, toInput].forEach(function (input) {
        input.min = dataMin;
        input.max = dataMax;
      });

      if (scaleMin) scaleMin.textContent = formatVal(dataMin);
      if (scaleMax) scaleMax.textContent = formatVal(dataMax);

      var activeNums = values
        .filter(function (v) { return v.active; })
        .map(function (v) { return parseFloat(v.value); })
        .filter(function (n) { return !isNaN(n); });

      fromInput.value = activeNums.length ? Math.min.apply(null, activeNums) : dataMin;
      toInput.value = activeNums.length ? Math.max.apply(null, activeNums) : dataMax;

      function updateVisuals(activeInput) {
        var fromVal = parseFloat(fromInput.value);
        var toVal = parseFloat(toInput.value);
        if (fromVal > toVal) {
          if (activeInput === toInput) {
            fromVal = toVal;
            fromInput.value = toVal;
          } else {
            toVal = fromVal;
            toInput.value = fromVal;
          }
        }
        var span = dataMax - dataMin;
        var pctFrom = span ? ((fromVal - dataMin) / span) * 100 : 0;
        var pctTo = span ? ((toVal - dataMin) / span) * 100 : 100;
        if (trackActive) {
          trackActive.style.left = pctFrom + '%';
          trackActive.style.width = (pctTo - pctFrom) + '%';
        }
        if (readoutFrom) readoutFrom.textContent = formatVal(fromVal);
        if (readoutTo) readoutTo.textContent = formatVal(toVal);
      }

      updateVisuals(fromInput);

      function applyRange() {
        // Rohposition = was der Nutzer eingestellt hat. Der Regler ist
        // stufenlos, die verfuegbaren Werte sind es nicht - vorher wurde die
        // Rohposition beim Filtern implizit abgeschnitten (von-Handle nach
        // oben, bis-Handle nach unten). Jetzt rastet beide Seiten explizit auf
        // den naechstgelegenen echten Wert ein.
        var rawFrom = parseFloat(fromInput.value);
        var rawTo = parseFloat(toInput.value);
        var snapFrom = scaffNearestValue(snapCandidates, rawFrom);
        var snapTo = scaffNearestValue(snapCandidates, rawTo);
        if (snapFrom > snapTo) {
          var swap = snapFrom;
          snapFrom = snapTo;
          snapTo = swap;
        }

        var fromOff = Math.abs(rawFrom - snapFrom) > noteThreshold;
        var toOff = Math.abs(rawTo - snapTo) > noteThreshold;

        // SCAFF24: Wurde die OBERE Grenze nach unten eingerastet, ist die
        // angezeigte Groesse kleiner als die gewuenschte. Wer eine
        // Mindestgroesse braucht (Wunsch 2,3 -> eingerastet 2,0), kann mit dem
        // kleineren Wert nichts anfangen, deshalb den naechstgroesseren
        // verfuegbaren Wert als zweite Option mit anbieten.
        // Der ist immer > rawTo: laege ein Kandidat zwischen snapTo und rawTo,
        // waere er naeher an rawTo und scaffNearestValue haette ihn gewaehlt.
        var upValue = null;
        if (toOff && snapTo < rawTo) {
          for (var ui = 0; ui < snapCandidates.length; ui++) {
            if (snapCandidates[ui] > snapTo + 0.0001) {
              upValue = snapCandidates[ui];
              break;
            }
          }
        }

        try {
          if (fromOff || toOff) {
            sessionStorage.setItem(SCAFF_RANGE_NOTE_KEY, JSON.stringify({
              path: window.location.pathname,
              param: paramName,
              label: container.dataset.label || '',
              unit: unit,
              fromOff: fromOff,
              toOff: toOff,
              rawFrom: rawFrom,
              rawTo: rawTo,
              snapFrom: snapFrom,
              snapTo: snapTo,
              upValue: upValue
            }));
          } else {
            scaffClearRangeNote();
          }
        } catch (e) {}

        // Handles/Readout sofort auf die eingerasteten Werte ziehen, damit
        // waehrend des Ladens schon der Wert steht, der tatsaechlich gilt.
        fromInput.value = snapFrom;
        toInput.value = snapTo;
        updateVisuals(fromInput);

        var matching = values.filter(function (v) {
          var n = parseFloat(v.value);
          return !isNaN(n) && n >= snapFrom - 0.0001 && n <= snapTo + 0.0001;
        });

        var url = new URL(window.location.href);
        url.searchParams.delete(paramName);
        matching.forEach(function (v) {
          url.searchParams.append(paramName, v.value);
        });

        scaffAjaxApplyUrl(url, container, paramName);
      }

      [fromInput, toInput].forEach(function (input) {
        input.addEventListener('input', function () {
          updateVisuals(input);
        });
        input.addEventListener('change', applyRange);
      });
    });
  }

  scaffInitRangeFilters(document);
});

